import React from "react";
import { useI18n } from "@/i18n";
import legal from "@/i18n/legal";
import Seo from "@/components/Seo";
import { Kicker, Section } from "@/components/Primitives";

const UPDATED = "2026-06-01";

export function LegalPage({ kind }) {
  const { lang, t } = useI18n();
  const content = (legal[lang] || legal.fr)[kind];
  const contactEmail = process.env.REACT_APP_LEGAL_CONTACT_EMAIL || "privacy@consultantsparks.com";

  return (
    <div data-testid={`${kind}-page`}>
      <Seo pageKey={kind} />
      <header className="border-b border-border bg-secondary/40">
        <div className="cs-container py-16 md:py-20">
          <Kicker>{content.kicker}</Kicker>
          <h1 className="mt-6 max-w-3xl font-display text-4xl font-light leading-tight sm:text-5xl">
            {content.title}
          </h1>
          <p className="mt-6 max-w-2xl text-sm text-muted-foreground sm:text-base">{content.lead}</p>
          <p className="mt-4 text-xs text-muted-foreground">
            {content.updated} : {UPDATED}
          </p>
        </div>
      </header>

      <Section>
        <div className="max-w-3xl space-y-12">
          {content.sections.map((section, index) => (
            <section key={section.title} data-testid={`${kind}-section-${index}`}>
              <h2 className="font-display text-2xl font-medium sm:text-3xl">{section.title}</h2>
              {section.body && (
                <p className="mt-4 text-sm leading-relaxed text-muted-foreground sm:text-base">{section.body}</p>
              )}
              {section.items && (
                <ul className="mt-4 space-y-3">
                  {section.items.map((item) => (
                    <li key={item} className="flex gap-3 text-sm leading-relaxed text-muted-foreground sm:text-base">
                      <span aria-hidden="true" className="mt-2 h-1 w-4 shrink-0 bg-accent" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}

          <section className="border-t border-border pt-10">
            <h2 className="font-display text-2xl font-medium">{content.contactTitle}</h2>
            <p className="mt-4 text-sm text-muted-foreground">
              <a data-testid={`${kind}-contact-email`} href={`mailto:${contactEmail}`} className="text-accent hover:underline">
                {contactEmail}
              </a>
            </p>
            <p data-testid={`${kind}-contact-address`} className="mt-4 whitespace-pre-line text-sm text-muted-foreground">
              {t("footer.address")}
            </p>
          </section>
        </div>
      </Section>
    </div>
  );
}

export const PrivacyPage = () => <LegalPage kind="privacy" />;
export const TermsPage = () => <LegalPage kind="terms" />;
